<template>
    <component :is="layout">
        <h1 class="heading">Добавить задачу</h1>

        <div
            v-for="category in categories"
            class="category"
            :key="category">

            <h2 class="small-heading">
                {{ category }}
            </h2>
            <ul class="methods-list">
                <router-link
                    v-for="method in methodsByCategory(category)"
                    :key="method.id"
                    :to="{name: 'addTask', params: { platform: platformKeyFromRoute, id: method.id}}"
                    class="method-link link strong"
                >
                    {{ method.name }}
                </router-link>
            </ul>
        </div>
    </component>
</template>

<script>
import SideBar from '../components/SideBar'
import PageContent from '../components/PageContent'

export default {
  name: 'MethodsList',
  components: {
    PageContent,
    SideBar
  },
  data() {
    return {
      layout: 'default-layout'
    }
  },
  computed: {
    currentPlatform() {
      return this.$store.state.platforms.find(platform => platform.code === this.platformKeyFromRoute)
    },
    platformKeyFromRoute() {
        return this.$route.params.platform
    },
    methodsToShow() {
      if (!this.$store.state.platforms.length) {
        return []
      }
      return this.currentPlatform.methods
    },
    categories() {
      if (this.currentPlatform === undefined) {
        return []
      }
      // console.log(this.$store.getters.categoriesByPlatform[this.currentPlatform.code])
      return this.$store.getters.categoriesByPlatform[this.currentPlatform.code]
    }
  },
  methods: {
    methodsByCategory(category) {
      return this.methodsToShow.filter(method => method.category === category)
    }
  }
}
</script>

<style lang="sass" scoped>
    .category
        margin-bottom: gridSteps(1)

    .methods-list
        padding: 0
        margin: 0
        list-style: none
        display: flex
        flex-flow: column

    .method-link
        margin-bottom: gridSteps(2)
</style>
